/**
 * Created by vladislav on 01/02/2023
 */

TileFactory.Construct = cleverapps.extendFunc(TileFactory.Construct, function (item) {
    return this._super(item);
});